var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasino(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H60C66.3513 0.5 71.5 5.64873 71.5 12V56C71.5 62.3513 66.3513 67.5 60 67.5H16C9.64873 67.5 4.5 62.3513 4.5 56V12C4.5 5.64873 9.64873 0.5 16 0.5Z",
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 8C24.4167 8 13 19.4167 13 33.5C13 47.5834 24.4167 59 38.5 59C52.583 59 63.9997 47.5834 63.9997 33.5C63.9997 19.4167 52.583 8 38.5 8ZM51.2018 14.622L49.5769 17.0238C47.4148 15.5673 44.95 14.5262 42.2971 14.0124L42.8672 11.1697C45.8552 11.7475 48.6803 12.9178 51.2018 14.622ZM39.8187 44.8173V47.7779H37.4104V44.8322C35.6902 44.6431 34.0759 43.9841 32.8621 42.8548C31.648 41.7256 31.0927 40.0655 31.1326 37.8763L31.1942 37.8006H35.4476C35.4476 39.1768 35.7537 40.0905 36.3655 40.6672C36.9776 41.2444 37.7558 41.5334 38.7013 41.5334C39.6066 41.5334 40.3006 41.2924 40.7831 40.8097C41.2656 40.3271 41.507 39.6783 41.507 38.8624C41.507 38.0563 41.2756 37.3998 40.813 36.8925C40.3505 36.385 39.5567 35.9127 38.4326 35.4747C36.2236 34.6686 34.5842 33.771 33.5148 32.7808C32.4451 31.7908 31.9105 30.3954 31.9105 28.5945C31.9105 26.9228 32.4047 25.5524 33.474 24.4828C34.5435 23.4133 36.0339 22.7839 37.7541 22.5946V19.394H40.1624V22.6243C41.8827 22.8831 43.3122 23.6144 44.3121 24.8182C45.3121 26.0222 45.8136 27.5665 45.7938 29.4866L45.7606 29.5435H41.507C41.507 28.3394 41.2656 27.482 40.7831 26.8452C40.3004 26.2085 39.6414 25.8989 38.8057 25.8989C37.9497 25.8989 37.3132 26.1496 36.8954 26.642C36.4774 27.1345 36.2687 27.7913 36.2687 28.607C36.2687 29.383 36.4899 30.0135 36.9327 30.496C37.3753 30.9787 38.1888 31.4544 39.373 31.9219C41.5718 32.7875 43.2012 33.713 44.2607 34.6982C45.3204 35.6832 45.8502 37.0614 45.8502 38.8324C45.8502 40.5637 45.272 41.9469 44.2076 42.9816C43.1429 44.0167 41.711 44.6283 39.8187 44.8173ZM34.1329 11.1697L34.682 14.0165C32.0299 14.5333 29.5662 15.5766 27.4054 17.0355L25.7982 14.622C28.3197 12.9178 31.1446 11.7475 34.1329 11.1697ZM19.622 20.798L22.0238 22.4229C20.5673 24.5851 19.5264 27.0497 19.0125 29.7026L16.1697 29.1325C16.7477 26.1447 17.918 23.3195 19.622 20.798ZM19.6219 46.2017C17.9176 43.6802 16.7475 40.855 16.1697 37.867L19.0165 37.3179C19.5333 39.97 20.5766 42.4339 22.0355 44.5946L19.6219 46.2017ZM25.7978 52.3778L27.4228 49.976C29.5849 51.4327 32.0497 52.4738 34.7028 52.9876L34.1327 55.8305C31.1445 55.2523 28.3192 54.0822 25.7978 52.3778ZM42.867 55.8305L42.3179 52.9837C44.9701 52.4669 47.4339 51.4236 49.5948 49.9645L51.202 52.378C48.6803 54.0824 45.855 55.2527 42.867 55.8305ZM57.378 46.2019L54.9762 44.5769C56.4327 42.4148 57.4736 39.9499 57.9875 37.2971L60.8302 37.8671C60.2522 40.8552 59.0821 43.6803 57.378 46.2019ZM57.9833 29.682C57.4666 27.0299 56.4233 24.566 54.9642 22.405L57.3776 20.7978C59.0819 23.3193 60.2521 26.1447 60.83 29.1327L57.9833 29.682Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58_2",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasino);
export default __webpack_public_path__ + "static/media/casino.39abbb08f0c30bffcc648846b629ea3b.svg";
export { ForwardRef as ReactComponent };